import type { Settings } from '../../types'
import {
    DisplayUeopt,
    PMPlaySoundOnUeopt,
    SettingsType,
} from '../constants/enums'
import { GridDensityUeopt } from '../mfcLogic/ueopts'

export const SETTINGSSTATE: Settings = {
    [SettingsType.DEFAULT]: {
        alerts: 0,
        animatePreviews: 1,
        animationSpeed: 10,
        colorScheme: null,
        enableFloatingPreview: true,
        display: DisplayUeopt.default,
        fullWindow: undefined,
        gridDensity: GridDensityUeopt.medium,
        groupBy: 'state',
        region: 0,
        regions: {
            1: { name: 'Africa', show: true, id: 'AF' },
            2: { name: 'Asia/Pacific Islands', show: true, id: 'AS' },
            4: { name: 'Australia', show: true, id: 'AU' },
            8: { name: 'Central/S. America', show: true, id: 'SA' },
            16: { name: 'Europe/Russia', show: true, id: 'EU' },
            32: { name: 'North America', show: true, id: 'NA' },
            64: { name: 'United Kingdom', show: true, id: 'UK' },
            128: { name: 'Unknown Region', show: true, id: 'UN' },
        },
        show: 'custom',
        sort: 'rating',
        pmNotification: 0,
        // pin to top
        pinFriends: 1,
        pinBookmarks: 1,
        pinTrendingRooms: 0,
        pinPopularRooms: 0,
        pinModelsYouMayLike: 1,
        pinModelsWithNotes: 0,
        pinNewModels: 0,
        pinMissMFC: 0,
        pinPrivateGroupShows: 0,
        pinRecentlyVisitedRooms: 0,
        pinCustomSelection: 1,
        pinPastWinners: 0,
        // pin to top custom amounts
        pinTrendingRoomsAmount: 10,
        pinPopularRoomsAmount: 10,
        pinModelsYouMayLikeAmount: 10,
        pinMissMFCAmount: 100,
        pinRecentlyVisitedRoomsAmount: 10,
        pinCustomSelectionAmount: 10,
        pmNotificationSound: 2,
        pmPlaySoundsOn: PMPlaySoundOnUeopt.receivedMessage,
    },
    [SettingsType.NEWS_NOTIFICATIONS]: {
        news: 3,
    },
    [SettingsType.MY_ACCOUNT]: {
        disableInChatQuickbuy: 0,
        tokenRevealLevel: 2,
        rpRevealLevel: 2,
        truePrivate: 0,
        privateGalleryOptOut: 0,
        administrativeEmails: 1,
        purchaseConfirmationEmails: 1,
    },
    [SettingsType.MY_WEBCAM]: {
        options: 32,
    },
    [SettingsType.ROOM]: {
        availableSpaceView: 'profile',
        chatFontColor: undefined,
        inlinePM: 32,
        // truePrivate: false,
        loungeAutoplay: 0,
    },
    [SettingsType.PRIVACY]: {
        privateMessages: 112,
    },
}

if (typeof window !== 'undefined') {
    window.__MFC_APP_SETTINGS__ = SETTINGSSTATE
}
